export default __webpack_public_path__ + "static/media/Rejected.9bf1533e.svg";